import { render, staticRenderFns } from "./selectTable.vue?vue&type=template&id=4745abd2&scoped=true"
import script from "./selectTable.vue?vue&type=script&lang=js"
export * from "./selectTable.vue?vue&type=script&lang=js"
import style0 from "./selectTable.vue?vue&type=style&index=0&id=4745abd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745abd2",
  null
  
)

export default component.exports